import { render, staticRenderFns } from "./MultiSelectionItems.vue?vue&type=template&id=688556f4&scoped=true&lang=html"
import script from "./MultiSelectionItems.vue?vue&type=script&lang=js"
export * from "./MultiSelectionItems.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectionItems.vue?vue&type=style&index=0&id=688556f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688556f4",
  null
  
)

export default component.exports